import { createUpdateSyncSlice, SyncState } from '@sonar-software/xuder';

export type ApplicationSidebar = {
	closed: boolean;
};

export type ApplicationSidebarRequest = { closed: boolean };

const defaultApplicationSidebarState: SyncState<ApplicationSidebar> = { data: { closed: false } };

export const applicationSidebarSyncSlice = createUpdateSyncSlice({
	name: 'ApplicationSidebar',
	state: defaultApplicationSidebarState,
	transform: (action: ApplicationSidebarRequest) => {
		const { closed = true } = action ?? {};

		return {
			closed
		};
	}
});
